"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const noop_1 = require("../helper/noop");
const ProgressStepper = ({ active, className, steps, onStepChange }) => {
    return (react_1.default.createElement("nav", { className: (0, classnames_1.default)('znd-progress-stepper', { ['znd-progress-stepper--disabled']: !onStepChange }, className) }, steps.map((step, index) => (react_1.default.createElement("div", { key: index, className: (0, classnames_1.default)('znd-progress-stepper__step', {
            'znd-progress-stepper__step--active': index <= active,
            'znd-progress-stepper__step--exact': index === active,
        }) },
        react_1.default.createElement("div", { className: "znd-progress-stepper__dot", onClick: () => (onStepChange ? onStepChange(index) : (0, noop_1.noop)()) }, step.label))))));
};
exports.default = (0, mobx_react_1.observer)(ProgressStepper);
